import * as React from "react";
const SvgWarningTriangleFilled = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M12 1.508c-.003 0-2.478 4.722-5.502 10.494L1 22.498l5.5.002h11l5.5-.002-5.498-10.496A7715.3 7715.3 0 0 0 12 1.508Zm-.998 8.496h1.996v6h-1.996v-3zm0 7.996h1.996v1.996h-1.996v-.998z", style: {
            clipRule: "evenodd",
            fill: "currentColor",
            fillRule: "evenodd",
        } })));
export default SvgWarningTriangleFilled;
